import api from '../api';
import TokenService from '../../services/authentication/TokenService';
import { plainToInstance } from 'class-transformer';
import { Token } from '../../models/authentication/Token.ts';

// const DEFAULT_OAUTH_HEADERS = {
//   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
//   'Authorization': `Basic ${TokenService.getLoginToken()}`
// }

const login = async ({ username, password }) => {
    try {
        const { data } = await api.request({
            url: `/api/analytics/auth/login`,
            method: 'POST',
            data: {
                email: username,
                password: password,
            },
        });

        // const { data } = await api.postForm(
        //     "/api/analytics/auth/login",
        //     {
        //         // grant_type: "password",
        //         email: username,
        //         password: password,
        //     },
        //     {
        //         baseURL: process.env.REACT_APP_OAUTH_URL,
        //         // headers: {
        //         //     "Content-Type": "application/json",
        //         //     // "Content-Type": "application/x-www-form-urlencoded",
        //         // },
        //     }
        // );
        TokenService.setData(data);
    } catch (error) {
        throw error;
    }
};

const logout = async () => {
    try {
        // eslint-disable-next-line no-unused-vars
        // const { data } = await api.postForm(
        //     "/api/analytics/auth/revoke",
        //     {
        //         token: TokenService.getAccessToken(),
        //     },
        //     {
        //         baseURL: process.env.REACT_APP_OAUTH_URL,
        //         headers: {
        //             "Content-Type": "application/json",
        //             // "Content-Type": "application/x-www-form-urlencoded",
        //         },
        //     }
        // );
        TokenService.removeData();
    } catch (error) {
        throw error;
    }
};

const refreshAuth = async () => {
    try {
        const { data } = await api.postForm(
            '/api/analytics/auth/token',
            {
                grant_type: 'refresh_token',
                refresh_token: TokenService.getRefreshToken(),
            },
            {
                baseURL: process.env.REACT_APP_OAUTH_URL,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            },
        );
        TokenService.setData(plainToInstance(Token, data));
    } catch (error) {
        throw error;
    }
};

const AuthService = {
    login,
    logout,
    refreshAuth,
};

export default AuthService;
